import axios from "./axios";
import { setHeaders } from "./baseApi";
import { apiPaths } from "./baseApi";
/**
 * @param {string} [context] - Contexte facultatif
 * @returns {Promise<any>}
 */

// modifier un homeWork
export const updateHomeworkAnswerByTeacher = async (id, payload, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/homeworkAnswer/updateAnswerByTeacher/${id}`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// Créer une réponse pour un devoir
export const createHomeworkAnswer = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/homeworkAnswer/create`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// modififer un homeWorkAnswer
export const updateHomeworkAnswer = async (id, payload, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/homeworkAnswer/updateAnswerByStudent/${id}`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};
